// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*filter list items -> filter/index */

.filterInfoText {
    max-width: 50em;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    color: gray;
    opacity: 0.6;
}

.filterInfoNumberDisplay {
    padding-left: 8px;
    font-size: 0.9em;
}

.titleContainer {
    margin-left: auto;
    margin-right: auto;
    padding: 8px;
}

.filterListItemVisible {
    display: block;
    padding: 4px;
}

.filterListItemVisibleLeftAnimation {
    display: block;
    padding: 4px;
    animation: moveLeftGlobal 1s;
    overflow-y: hidden;
}

.filterListItemVisibleRightAnimation {
    display: block;
    padding: 4px;
    animation: moveRightGlobal 1s;
    overflow-y: hidden;
}

.filterListItemNotVisible {
    display: none;
}

.filterContainerToggleBlur {
    display: flex;
    justify-content: center;
}

.filterContentContainer {
    display: flex;
    justify-content: left;
    background-color: var(--filterColorTopBar);
    border-radius: 5px;
    padding: 0.5em;
    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);
    animation: fadeInGlobal 2s;
    min-height: 2.8em;
}

.FilterContentButtonContainer {
    display: inline-flex;
    margin-top: 4px;
}

.FilterContentButtonContainerBlueButtonSmall {
    margin-left: 0.1em;
}

.FilterContentButtonContainerDarkerBlueButtonSmall {
    margin-left: 0.5em;
}

.centerText {
    text-align: center;
}

.infoTextFilterList {
    display: inline-block;
    color: var(--filterColorMiddleContainer);
    margin: 4px 20px;
    margin-top: auto;
    margin-bottom: auto;
}

.infoTextFilterListSucceeded {
    display: inline-block;
    color: var(--filterColorSuccess);
    margin: 4px 20px;
    margin-top: auto;
    margin-bottom: auto;
}

.infoTextFilterListUpdate {
    display: inline-block;
    color: var(--filterColorMiddleContainer);
    margin: 4px 20px;
    margin-top: auto;
    margin-bottom: auto;
}

.infoTextFilterListDelete {
    display: inline-block;
    color: var(--filterColorError);
    margin: 4px 20px;
    margin-top: auto;
    margin-bottom: auto;
}

.infoTextFilterListError {
    display: inline-block;
    color: var(--filterColorError);
    margin: 4px 20px;
    margin-top: auto;
    margin-bottom: auto;
}

.inputContainerFilterBlur {
    filter: blur(0.4rem);
    pointer-events: none;
}

.inputContainerFilterShow {
    filter: blur(0);
    pointer-events: all;
}

@media only screen and (max-width: 830px) {
    .FilterContentButtonContainer {
        display: inline-flex;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Filters/FilterContent/FilterContent.css"],"names":[],"mappings":"AAAA,qCAAqC;;AAErC;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,4BAA4B;IAC5B,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,0CAA0C;IAC1C,kBAAkB;IAClB,cAAc;IACd,+CAA+C;IAC/C,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,wCAAwC;IACxC,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ","sourcesContent":["/*filter list items -> filter/index */\n\n.filterInfoText {\n    max-width: 50em;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n    color: gray;\n    opacity: 0.6;\n}\n\n.filterInfoNumberDisplay {\n    padding-left: 8px;\n    font-size: 0.9em;\n}\n\n.titleContainer {\n    margin-left: auto;\n    margin-right: auto;\n    padding: 8px;\n}\n\n.filterListItemVisible {\n    display: block;\n    padding: 4px;\n}\n\n.filterListItemVisibleLeftAnimation {\n    display: block;\n    padding: 4px;\n    animation: moveLeftGlobal 1s;\n    overflow-y: hidden;\n}\n\n.filterListItemVisibleRightAnimation {\n    display: block;\n    padding: 4px;\n    animation: moveRightGlobal 1s;\n    overflow-y: hidden;\n}\n\n.filterListItemNotVisible {\n    display: none;\n}\n\n.filterContainerToggleBlur {\n    display: flex;\n    justify-content: center;\n}\n\n.filterContentContainer {\n    display: flex;\n    justify-content: left;\n    background-color: var(--filterColorTopBar);\n    border-radius: 5px;\n    padding: 0.5em;\n    box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.3);\n    animation: fadeInGlobal 2s;\n    min-height: 2.8em;\n}\n\n.FilterContentButtonContainer {\n    display: inline-flex;\n    margin-top: 4px;\n}\n\n.FilterContentButtonContainerBlueButtonSmall {\n    margin-left: 0.1em;\n}\n\n.FilterContentButtonContainerDarkerBlueButtonSmall {\n    margin-left: 0.5em;\n}\n\n.centerText {\n    text-align: center;\n}\n\n.infoTextFilterList {\n    display: inline-block;\n    color: var(--filterColorMiddleContainer);\n    margin: 4px 20px;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.infoTextFilterListSucceeded {\n    display: inline-block;\n    color: var(--filterColorSuccess);\n    margin: 4px 20px;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.infoTextFilterListUpdate {\n    display: inline-block;\n    color: var(--filterColorMiddleContainer);\n    margin: 4px 20px;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.infoTextFilterListDelete {\n    display: inline-block;\n    color: var(--filterColorError);\n    margin: 4px 20px;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.infoTextFilterListError {\n    display: inline-block;\n    color: var(--filterColorError);\n    margin: 4px 20px;\n    margin-top: auto;\n    margin-bottom: auto;\n}\n\n.inputContainerFilterBlur {\n    filter: blur(0.4rem);\n    pointer-events: none;\n}\n\n.inputContainerFilterShow {\n    filter: blur(0);\n    pointer-events: all;\n}\n\n@media only screen and (max-width: 830px) {\n    .FilterContentButtonContainer {\n        display: inline-flex;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
